import React, { useState } from 'react';
import PlanningHorizonLayer from './PlanningHorizonLayer';
import TaskTypeListLayer from './TaskTypeListLayer';
import TaskCodeListLayer from './TaskCodeListLayer';
import ModifierCodeListLayer from './ModifierCodeListLayer';
import AssetSystemListLayer from './AssetSystemListLayer';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';




const TaskReferencesLayer = () => {
  const userProfile = useUserProfile();
  const tabs = [
    { key: 'task-type', label: 'Task Type', Component: TaskTypeListLayer },
    { key: 'asset-system', label: 'System', Component: AssetSystemListLayer },
  ];

  if (userProfile?.privileges?.includes('tasks:view')) {
    tabs.push({
      key: 'task-code',
      label: 'Task Code',
      Component: TaskCodeListLayer
    })

    tabs.push({
      key: 'modifier-code',
      label: 'Modifier Code',
      Component: ModifierCodeListLayer
    })

    tabs.push({
      key: 'planning-horizon',
      label: 'Planning Lead Time',
      Component: PlanningHorizonLayer
    })
  }

  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find(t => t.key === activeTab).Component;

  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default TaskReferencesLayer;
